import { schema } from 'normalizr';

export const assetsImagesSchema = new schema.Entity(
  'images', 
  {},
  { idAttribute: 'guid' }
);